export default __webpack_public_path__ + "static/media/david-hawig.8b1b5714.jpeg";